import styled from 'styled-components';
import { CircularProgress } from '@mui/material';
import { FlexCenter } from '../Flex';

const Wrapper = styled(FlexCenter)`
  height: 100%;
  margin: auto;
  color: ${({ theme }) => theme.palette.accent.primary};
`;

type Props = {
  size?: number;
};

function Loading({ size }: Props) {
  return (
    <Wrapper>
      <CircularProgress size={size} />
    </Wrapper>
  );
}

export default Loading;
